// @ts-nocheck
import React from "react";
import {TextFieldRojo} from "../App";

export default function FormInput(props){

    const {name, label, value, errorText, onChange, ...otherProps} = props;
    return (
        <TextFieldRojo
            variant="outlined"
            name={name}
            helperText={errorText}
            label={label}
            value={value}
            onChange={onChange}
            {...otherProps}
        />
    )
}